export default {
    close: 'Close',
    title: {
        trends: 'Trends',
        regions: 'Region',
        industries: 'Industry',
        trendradars: 'Trend radar',
        innovationTypes: 'Innovation type',
        sdgs: 'SDGs'
    },
    search: {
        trends: 'trends',
        regions: 'region',
        industries: 'industry',
        innovationTypes: 'innovation type',
        trendradars: 'Trend radar',
        title: 'Search for {title}',
        sdgs: 'SDGs'
    }
}
